import React from "react";
import { Row } from "antd";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { connectHits } from "react-instantsearch-dom";
import ProductActions from "redux/actions/productActions";
import ProductCard from "./ProductCard";


const InfiniteHits = ({
  hits,
  checkedProducts,
  actions,
}) => {
  const { id } = useParams();

  const onClickCard = (e, product, isCheck) => {
    // firebase does not allow to add keys with special characters
    delete product["transformedAttributes"]
    delete product["_highlightResult"]
   
    if (isCheck) {
       actions.addProduct(product, id);
    } else {
     actions.removeProduct(product, id);
    }
  };

  return (
    <div>
      <Row>
        {hits.map((item, index) => {
          return (
            <ProductCard
              key={index}
              item={item}
              index={index}
              handleProductSelection={onClickCard}
              isChecked={checkedProducts.some((it) => it?.id === item?.id)}
            />
          );
        })}
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  checkedProducts: state.checkedProducts.data,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      addProduct: ProductActions.addProduct,
      removeProduct: ProductActions.removeProduct,
    },
    dispatch
  ),
});

const CustomInfiniteHits = connectHits(
  connect(mapStateToProps, mapDispatchToProps)(InfiniteHits)
);

export default CustomInfiniteHits;
